import React, { useState, useEffect, useContext } from 'react';
import { FieldContext } from '../../hooks/Contexts';
import Icon from '../common/Icon';
import { parseError } from '../../helpers/errors';
import EntryItem from './EntryItem';
import {
  createMetadataEntry,
  destroyMetadataEntry,
  updateMetadataEntry,
} from './constants/handleMetaEntries';
import { notify } from '../../helpers/notifications';

const MetadataEntries = ({ metaEntries, setMetaEntries }) => {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');
  const { field } = useContext(FieldContext);
  const toggleCreating = () => setCreating(!creating);

  useEffect(() => {
    if (creating) {
      document.getElementById('new-me').focus();
    }
  }, [creating]);

  const handleCreateMetaEntry = async (e) => {
    if (e.key === 'Enter') {
      if (!e.target.value.length) {
        return setCreating(false);
      }
      let metadata_entry = {
        field_id: field.id.toString(),
        title: e.target.value,
      };
      let created = await createMetadataEntry(metadata_entry);
      if (created.ok) {
        setMetaEntries([...metaEntries, created.data]);
        setCreating(false);
        setError('');
      } else if (created.errors) setError(parseError(created));
    }
  };

  const handleUpdateMetaEntry = async (event, title, id) => {
    let updated = await updateMetadataEntry(id, title);
    if (updated.ok) {
      event.target.blur();
      setMetaEntries((entries) => {
        let entry = entries.find((me) => me.id == id);
        entries[entries.indexOf(entry)].title = title;
        return [...entries];
      });
      setError('');
      notify.alertSuccess(
        'Notice',
        'Title has been changed.<br/><br/>Mailers referencing this metadata title have been updated automatically.'
      );
    } else if (updated.errors) {
      setError(parseError(updated));
    }
    // lets child component know whether to toggle edit state
    return updated.ok || false;
  };

  const handleDestroyMetaEntry = async (e, id) => {
    e.preventDefault();
    await destroyMetadataEntry(id, (response) => {
      if (response.ok)
        setMetaEntries((entries) => {
          return entries.filter((me) => me.id != id);
        });
      setError('');
      notify.alertWarning(
        'Warning',
        'Mailers referencing this metadata title can not be updated automatically!<br/><br/>Visit form mailers and address any potential problems.'
      );
    });
  };

  return (
    <section className='metadata-entries'>
      <h2>Metadata Entries</h2>
      {error && (
        <div className='errors'>
          <span>{error}</span>
        </div>
      )}
      <ol className='items'>
        {metaEntries.map((me, i) => {
          return (
            <EntryItem
              me={me}
              key={me.id}
              destroyME={handleDestroyMetaEntry}
              updateME={handleUpdateMetaEntry}
              setError={setError}
            />
          );
        })}
        {creating ? (
          <li className='inline-input'>
            <div className='cargo'>
              <div className='name'>
                <div className='content'>
                  <span>
                    <input
                      style={{ width: '100%' }}
                      id='new-me'
                      type='text'
                      onKeyDown={handleCreateMetaEntry}
                      onBlur={toggleCreating}
                    />
                  </span>
                </div>
                <Icon
                  icon='xmark'
                  title='Cancel'
                  onClick={() => {
                    setCreating(false);
                  }}
                />
              </div>
            </div>
          </li>
        ) : (
          <li className='new-me'>
            <div className='cargo'>
              <Icon
                className='create'
                role='button'
                title='Add Metadata Entry'
                icon='plus'
                onClick={toggleCreating}
              />
            </div>
          </li>
        )}
      </ol>
    </section>
  );
};

export default MetadataEntries;
